export const timeIntervals = {
  POINT_CHECK: 20000,
  FIRST_POPUP_DELAY: 2500,
  NEXT_POPUP_DELAY: 1500,
}